import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import DOMPurify from "dompurify";
import { Accordion, AccordionItem } from '@szhsin/react-accordion';


function Content(select_field) {
    return select_field.map((field, fieldIndex) => {
        
            switch (field.acf_fc_layout) {
                case "module":
                    return (
                        <div>
                            <div key={fieldIndex}>

                                    {(field.add_speech || []).map((moduleDetail, speakerIndex) => (
                                        <div className="grid sm:grid-cols-4 gap-5 px-3 pb-3 pt-10" key={speakerIndex}>
                                            <div className="speaker md:mb-0 flex flex-wrap items-start gap-3 sm:col-span-2">
                                                <div className="w-[100px]">{moduleDetail.time_speach}</div>
                                                <h3 className="w-[calc(100%-115px)]">{moduleDetail.solo_speach_theme}</h3>
                                            </div>
                                            <div className="sm:col-span-2">
                                                {
                                                    moduleDetail.author_speach ? moduleDetail.author_speach.map((author, index) => {
                                                        return (
                                                            <div className="flex flex-wrap mb-5">
                                                                <div className="w-[100px] h-[100px] mr-[15px] relative overflow-hidden">
                                                                    <img
                                                                        className="relative z-20"
                                                                        src={author.acf.sm_image}
                                                                        alt={author.post_title}/>
                                                                    <div className="absolute bottom-0 left-0 w-full h-full bg-[#8C98FF]/80 transform-gpu skew-x-[30deg] z-10" />
                                                                </div>
                                                                <div className="w-[calc(100%-115px)]">
                                                                    <h3 className="text-[1.1em]">{author.post_title}</h3>
                                                                    <p>{author.acf.position_short}</p>
                                                                </div>
                                                            </div>
                                                        )
                                                    }) : ''
                                                }
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>

                    );
                case "module_workshop":
                    return (
                        <div>
                            <div key={fieldIndex}>

                                {
                                    field.add_speech.map((moduleDetail, speakerIndex) => (
                                        <div className="sm:flex grid gap-5 px-3 pb-3 pt-10" key={speakerIndex}>
                                            <div className="flex flex-wrap items-start gap-3 w-[100px] max-w:mb-3">
                                                <div className="w-[100px]">{moduleDetail.time_speach}</div>
                                            </div>
                                            <div className="sm:col-span-2">
                                                {
                                                    moduleDetail.author_speach ? moduleDetail.author_speach.map((author, index) => {
                                                        return (
                                                            <div className="flex flex-wrap mb-5">
                                                                <div className="w-[100px] h-[100px] mr-[15px] relative overflow-hidden">
                                                                    <img
                                                                        className="relative z-20"
                                                                        src={author.acf.sm_image}
                                                                        alt={author.post_title}/>
                                                                    <div className="absolute bottom-0 left-0 w-full h-full bg-[#8C98FF]/80 transform-gpu skew-x-[30deg] z-10" />
                                                                </div>
                                                                <div className="w-[calc(100%-115px)]">
                                                                    <h3 className="text-[1.1em]">{author.post_title}</h3>
                                                                    <p>{author.acf.position_short}</p>
                                                                </div>
                                                            </div>
                                                        )
                                                    }) : ''
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                    );
                default:
                    return null;
            }
        })

}

const EventProgram = ({ programData = [] }) => {
    if (!programData.length) return null;

    return (
        <section className="py-10" id="programm">
            <div className="container max-w-screen-xl px-4 w-[90%] sm:w-full mx-auto z-30 relative">

                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h2 className="text-4xl uppercase mb-2 title-design before:bg-[#8c98ff33] after:bg-[#8c98ff33]"><span>Програма</span></h2>
                    <p className="text-gray-600/60 mb-9">* Програма формується. Слідкуйте за оновленнями</p>
                </ScrollAnimation>
                <Accordion allowMultiple transition transitionTimeout={250}>
                    {programData.map((item, index) => {
                        return item.acf.program_fields.map((layoutData, subIndex) => {
                            const {program_time, select_field} = layoutData
                            const titleAccordion = '<div>'+ program_time +'</div> '+ select_field[0].theme_speech
                            return (
                                subIndex === 8 ?
                                <AccordionItem className="mb-5 border border-1 w-full" key={subIndex} header={
                                    <div className="flex flex-wrap w-full">
                                        <div className="p-3 bg-[#8C98FF] w-[120px]">{program_time}</div>
                                        <div className="p-3 bg-[#8C98FF]/20 w-[calc(100%-120px)] text-left">
                                            {select_field[0].theme_speech}
                                        </div>
                                    </div>
                                } initialEntered >
                                    {Content(select_field)}
                                </AccordionItem> :
                                <AccordionItem className="mb-5 border border-1" key={subIndex} header={
                                    <div className="flex flex-wrap w-full">
                                        <div className="p-3 bg-[#8C98FF] w-[120px]">{program_time}</div>
                                        <div className="p-3 bg-[#8C98FF]/20 w-[calc(100%-120px)] text-left">
                                            {select_field[0].theme_speech}
                                        </div>
                                    </div>
                                } >
                                    {Content(select_field)}
                                </AccordionItem>

                            );
                        });
                    })}
                </Accordion>
                <p className="text-gray-600/60 ">*Склад спікерів та теми виступів можуть змінюватись впродовж програми за рішенням організаторів </p>

            </div>

        </section>
    );
};

export default EventProgram;